<template>
  <el-header>
    <section
      class="el-header"
      ref="headers"
    >
      <div class="headers1">
        <div class="headerContent">
          <span class="slogan">{{headerText[0].classification_name_cn}}</span>
          <div class="CNEN">
            <div :class="searnone?'sdiv':'sdiv1'">
              <el-input
                size="mini"
                placeholder="请输入内容"
                v-model="input4"
                class="input"
                @blur='blurclick()'
                @keyup.enter.native='searchList()'
              >
              </el-input>
              <img
                class="search"
                src="../../static/image/search.png"
                alt=""
                @click="searchList()"
              >
            </div>
            <!-- suffix-icon="el-icon-search" -->
            <img
              :class="!searnone?'search':'search1'"
              src="../../static/image/search.png"
              alt=""
              @click="searchClick()"
            >
            <span
              :class="language?'language cutover':'language'"
              @click="languageCutover(1)"
            >中</span>
            <span
              :class="!language?'language cutover':'language'"
              @click="languageCutover(2)"
            >En</span>
          </div>
        </div>
      </div>
      <div class="logoRegion">
        <div class="headerContent">
          <img
            class="leftLogo"
            src="http://mjxc.oss-cn-beijing.aliyuncs.com/upload/20210420/bd9fe45d6ed9f13a08a606587fbb7447.png"
            alt=""
          >
          <div class="rightLogo">
            <img
              class="dadao"
              src="../../static/image/dadao.png"
              alt=""
            >
            <p class="tel">TEL：{{headerPhone[0].classification_name_cn}}</p>
          </div>
        </div>
      </div>
      <div
        class="nav"
        v-if="language"
        key="lang"
      >
        <ul
          ref="uls"
          :class="ulWidth?'ul':''"
        >
          <li
            :class="$route.path==item.navbar_url?'li li1':'li'"
            v-for="(item,i) in navList"
            :key="i"
            @click="navClick(item)"
          >
            <p :class="!ulWidth1?'CN':'CN CNSize'">{{item.navbar_name_cn}}</p>
            <p class="EN">{{item.navbar_name_en}}</p>
          </li>
        </ul>
      </div>
      <div
        class="nav navEn"
        v-else
        key="lang"
      >
        <ul
          ref="uls"
          :class="ulWidth?'ul':''"
        >
          <li
            :class="$route.path==item.navbar_url?'li li1':'li'"
            v-for="(item,i) in navList"
            :key="i"
            @click="navClick(item)"
          >
            <p :class="!ulWidth1?'CN':'CN CNSize'">{{item.navbar_name_cn}}</p>
          </li>
        </ul>
      </div>
    </section>
  </el-header>
</template>
<script>
import { removeToken } from "@/utils/token";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { NavgetList } from "@/api/Navbar";
import { ClassificationGetList } from "@/api/home";
export default {
  name: "app-header",
  data() {
    return {
      input4: "", //搜索内容
      searnone: false, //显示搜索框
      language: true, //语言
      navList: [], //导航栏
      ulWidth: false, //判定ul类名
      ulWidth1: false, //判定中文类名
      headerText: [{}],
      headerPhone: [{}]
    };
  },
  computed: {
    ...mapState("user", ["headerHeight"])
  },
  methods: {
    ...mapMutations("user", ["SET_GRADEID"]),
    // 搜索
    searchClick() {
      this.searnone = true;
    },
    blurclick() {
      if (this.input4.length <= 0) {
        this.searnone = false;
      }
    },
    // 语言切换
    languageCutover(i) {
      if (i == 1 && i != sessionStorage["lang"]) {
        // this.language = true;
        sessionStorage["lang"] = 1;
        this.$router.go(0);
      } else if (i == 2 && i != sessionStorage["lang"]) {
        // this.language = false;
        sessionStorage["lang"] = 2;
        this.$router.go(0);
      }
    },
    // 监听高度和宽度
    headerHeightAdd() {
      // console.log(this.$refs.uls.offsetWidth)
      if (this.$refs.uls) {
        if (this.$refs.uls.offsetWidth < 1300) {
          this.ulWidth = true;
        } else {
          this.ulWidth = false;
        }
        if (this.$refs.uls.offsetWidth <= 1100) {
          this.ulWidth1 = true;
        } else {
          this.ulWidth1 = false;
        }
      }
      if (this.$refs.headers) {
        var hei = this.$refs.headers.offsetHeight;
        this.SET_GRADEID(hei);
      }
    },
    // 导航栏跳转
    navClick(item) {
      this.$router.push({ path: item.navbar_url });
    },
    // 顶部导航栏文字和电话
    Plate(i, x) {
      ClassificationGetList({
        address: i,
        limit: x
      }).then(res => {
        // console.log(res);
        if (i == 7) {
          this.headerText = res.data.list;
        } else if (i == 8) {
          this.headerPhone = res.data.list;
        }
      });
    },
    // 搜索跳转
    searchList(){
      // console.log(this.input4)
      var laber = [0, 44,];
      var laPath = ["/",];
      this.$router.push({
        path: "/NewsList",
        query: {
          laber: JSON.stringify(laber),
          skey:this.input4,
          laPath: JSON.stringify(laPath)
        }
      });
      if(this.$route.path=='/NewsList'){
        this.$router.go(0)
      }
    }
  },
  mounted() {
    window.addEventListener("resize", this.headerHeightAdd);
    this.headerHeightAdd();
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeightAdd);
  },
  created() {
    var language = sessionStorage["lang"];
    if (!language || language == 1) {
      sessionStorage["lang"] = 1;
      this.language = true;
    } else {
      this.language = false;
    }
    NavgetList({}).then(res => {
      // console.log(res)
      this.navList = res.data;
    });
    // 顶部文字
    this.Plate(7, 1);
    // 顶部电话
    this.Plate(8, 1);
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/custom/common.scss";
.el-header {
  height: px2Rem(220px) !important;
  padding: 0;
  width: 100%;
  z-index: 2;
  overflow-y: hidden;
}
.headers1 {
  height: 18.1%;
  background: rgba(28, 50, 120, 1);
}
.headerContent {
  position: relative;
  width: px2Rem(1300px);
  min-width: 1100px;
  margin: auto;
  // text-align: center;
  height: 100%;
  // font-family: "STXinwei";
  .slogan {
    display: inline-block;
    position: absolute;
    top: 50%;
    transform: translate(0%, -50%);
    font-size: px2Rem(18px);
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }
  .CNEN {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate(0%, -50%);
    .sdiv {
      display: inline-block;
      transition: 0.3s;

      .input {
        width: 200px;
        margin-right: 10px;
        transition: 0.3s;
        font-size: px2Rem(18px);
        font-weight: 400;
        /deep/ input {
          height: px2Rem(28px);
          line-height: px2Rem(28px);
        }
      }
      .search {
        width: px2Rem(16px);
        height: px2Rem(16px);
        transition: 0.3s;
      }
    }
    .sdiv1 {
      display: inline-block;
      transition: 0.3s;
      .input {
        width: 0px;
        /deep/ input {
          padding: 0;
          border: none;
          transition: 0.3s;
        }
        transition: 0.3s;
      }
      .search {
        width: 0px;
        // height: 0px;
        // transition: 0.3s;
      }
    }
    .search {
      position: absolute;
      top: 50%;
      transform: translate(0%, -50%);
      width: px2Rem(16px);
      height: px2Rem(16px);
      cursor: pointer;
    }
    .search1 {
      display: none;
    }
    .language {
      display: inline-block;
      top: px2Rem(3px);
      font-size: px2Rem(18px);
      // font-family: STXinwei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      cursor: pointer;
      &:first-of-type {
        margin-left: px2Rem(30px);
      }
    }
    .cutover {
      padding: px2Rem(5px);
      background: rgba(226, 187, 129, 1);
    }
  }
}
.logoRegion {
  height: 52.5%;
  clear: both;
  .leftLogo {
    display: inline-block;
    // float: left;
    position: absolute;
    // right: 27%;
    top: 50%;
    transform: translate(0%, -50%);
    width: px2Rem(344px);
    height: px2Rem(76px);
  }
  .rightLogo {
    display: inline-block;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate(0%, -50%);
    font-size: 0;
    .dadao {
      width: px2Rem(237px);
      height: px2Rem(18px);
    }
    .tel {
      margin-top: 4%;
      font-size: px2Rem(18px);
      font-family: "Arial";
      font-weight: 400;
      color: rgba(28, 50, 120, 1);
      text-align: right;
    }
  }
}
.nav {
  height: 29.2%;
  // background: #fff;
  border-top: 1px solid #eee;
  ul {
    position: relative;
    display: flex;
    width: px2Rem(1300px);
    min-width: 1100px;
    margin: auto;
    padding: px2Rem(8px) 0;
    font-size: 0;
    text-align: center;
    clear: both;
  }
  .li {
    display: inline-block;
    font-size: 0;
    cursor: pointer;
    vertical-align: top;
    text-align: center;
    white-space: nowrap;
    color: #696969;
    &:hover {
      color: #1c3278;
    }
    .CN {
      font-size: px2Rem(24px);
      // font-family: STXinwei;
      font-weight: 400;
      // color: rgba(28, 50, 120, 1);
    }
    .CNSize {
      font-size: 18px;
    }
    .EN {
      padding-top: px2Rem(5px);
      font-size: 12px;
      // font-size:px2Rem(14px);
      font-family: Arial;
      font-weight: 400;
      // color: rgba(102, 102, 102, 1);
    }
    &:nth-of-type(1) {
      margin-right: 5%;
    }
    &:nth-of-type(2) {
      margin-right: 3%;
    }
    &:nth-of-type(3) {
      margin-right: 1.8%;
    }
    &:nth-of-type(4) {
      margin-right: 2%;
    }
    &:nth-of-type(5) {
      margin-right: 0.8%;
    }
    &:nth-of-type(6) {
      margin-right: px2Rem(9px);
    }
    &:nth-of-type(7) {
      margin-right: 3%;
    }
    &:nth-of-type(8) {
      margin-right: 3.5%;
    }
    &:nth-of-type(9) {
      margin-right: 2%;
    }
    &:nth-of-type(10) {
      // margin-right: 2%;
      // float: right;
      position: absolute;
      right: 0;
    }
  }
  .li1 {
    color: #1c3278;
  }
  .ul {
    .li {
      &:nth-of-type(1) {
        margin-right: 3%;
      }
      &:nth-of-type(7) {
        margin-right: 2.2%;
      }
      &:nth-of-type(8) {
        margin-right: 2.2%;
      }
    }
  }
}
.navEn {
  .ul{
    // display: block;
    .li{
      // width: 110px;
      .CNSize {
      font-size:14px;
    }
    }
  }
  .li {
    // max-width: px2Rem(130px);
    white-space: normal;
    vertical-align: top;
    margin-right:2% !important;
    &:last-of-type{
      position: relative;
      margin-right: 0 !important;
      text-align: right;
    }
    &:first-of-type{
       text-align: left;
    }
    .CN {
      // font-family:Arial;
      font-size: px2Rem(18px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/AppHeaderOne.vue